module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/device_contact_syncing.e902c18014f75fe5a6a5799924a4b819.svg";